import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  min-height: 25px;
`;

const Title = styled.p`
  color: tomato;
  font-weight: bold;
`;

const Message = styled.p`
  font-size: 0.9em;
`;

const Stack = styled.pre`
  overflow: auto;
  font-size: 0.7em;
  background-color: #e6e6e6;
  padding: 5px;
`;

function ErrorMessage({ error }) {
  const isDev = process.env.NODE_ENV === 'development';
  const is400 = error?.response?.status === 400;
  const detailsMessage = error?.response?.data?.details?.message;

  return (
    <Wrapper>
      {error && (
        <>
          <Title>An error occurred</Title>
          <Message>{is400 && detailsMessage ? detailsMessage : error.message}</Message>
          {isDev && <Stack>{error.stack}</Stack>}
        </>
      )}
    </Wrapper>
  );
}

ErrorMessage.propTypes = {
  error: PropTypes.object,
};

export default ErrorMessage;
